import { Badge, Group, Text } from '@mantine/core'
import type { FirmwareVeredito } from '@/api/robo'

/** A célula de firmware da Frota (e a linha "Firmware" do detalhe): modelo e
 * versão, com um selo quando o robô não está simplesmente em dia. */
export function FirmwareSelo({ firmware, bruto }: { firmware: FirmwareVeredito; bruto: string | null }) {
  if (firmware.estado === 'anterior') {
    if (!bruto) return <Text size="sm" c="dimmed">—</Text>
    return (
      <Group gap={6} wrap="nowrap">
        <Text size="xs" ff="monospace">{bruto}</Text>
        <Badge color="gray" variant="light">Anterior ao versionamento</Badge>
      </Group>
    )
  }
  const rotulo = firmware.nome && firmware.versao ? `${firmware.nome} ${firmware.versao}` : (bruto ?? '—')
  return (
    <Group gap={6} wrap="nowrap">
      <Text size="sm">{rotulo}</Text>
      {firmware.estado === 'desatualizado' && (
        <Badge color="yellow" variant="light">{`${firmware.ultima} disponível`}</Badge>
      )}
      {firmware.estado === 'desenvolvimento' && <Badge color="inovareTeal" variant="light">Desenvolvimento</Badge>}
      {firmware.estado === 'candidata' && <Badge color="gray" variant="light">Candidata</Badge>}
      {firmware.estado === 'desconhecido' && <Badge color="red" variant="light">Versão desconhecida</Badge>}
    </Group>
  )
}
